import React from 'react';
import PropTypes from 'prop-types';

const SectionTitle = (props) => {
  const { value } = props;

  return (
    <h4>{value}</h4>
  );
};

SectionTitle.propTypes = {
  value: PropTypes.string.isRequired,
};

export default SectionTitle;
